import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { RelatiesService } from 'src/app/shared/dataservices/relaties.service';
import { ToastrService } from 'ngx-toastr';
import { ObjectenService } from 'src/app/shared/dataservices/objecten.service';
import { ObjectSelect } from 'src/app/shared/model/models';
import { OfferteObject, OfferteSelect } from 'src/app/shared/model/offerte';
import { OfferteService } from 'src/app/shared/dataservices/offerte.service';
import { GeneralFunctionsService } from 'src/app/shared/general-functions.service';


@Component({
  selector: 'app-offerte-filter',
  templateUrl: './offerte-filter.component.html',
  styleUrls: ['./offerte-filter.component.less']
})
export class OfferteFilterComponent implements OnInit {



  @Output() selectionChanged = new EventEmitter< Array<OfferteObject>>();

  objectNR: string;
  offerteNR: string;
  objecten: Array<OfferteObject>
  objectenFilter :  Array<OfferteObject>


  constructor(private offerteService: OfferteService,
              private functions: GeneralFunctionsService,
              private toastr: ToastrService) { }

  ngOnInit() {
    this.offerteService.getObjecten().subscribe(list=>
      {
        this.objecten = list
        const data = localStorage.getItem("offertefilter");
        if (data) {
          const os = JSON.parse(data) as OfferteSelect;
          this.offerteNR = os.offerteNR;
          this.objectNR = os.objectNR;
        } else {
          this.objectenFilter = this.objecten;
        }
        this.doFilter();
      });
  }


  doFilter() {
    let oselect = new OfferteSelect();
    oselect.offerteNR = this.offerteNR;
    oselect.objectNR = this.objectNR;
    localStorage.setItem("offertefilter",JSON.stringify(oselect));
    this.objectenFilter = this.objecten.filter( data => {
      let filter = true;
      if (oselect.objectNR != null) {
        filter = data.ObjectNummer.toString().startsWith(oselect.objectNR)
      }
      if (oselect.offerteNR != null) {
        filter = filter && data.ID.toString().startsWith(oselect.offerteNR)
      }
      return  filter;
    })
    this.selectionChanged.emit(this.objectenFilter)
  }

  doClear() {
    const oselect = new OfferteSelect();
    oselect.offerteNR = this.offerteNR;
    oselect.objectNR = this.objectNR;
    this.offerteNR = null;
    this.objectNR = null;
    localStorage.setItem("offertefilter",JSON.stringify(oselect));
    this.objectenFilter = this.objecten;
    this.selectionChanged.emit(this.objectenFilter)
  }


}
